import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectAddCommentStatus = createSelector(
  [(store: RootState) => store.documentUpdate.addCommentStatus],
  (data) => data
);
